;(function (root, factory) {
    // UMD/AMDWeb module bolierplate: https://github.com/umdjs/umd/blob/master/templates/amdWeb.js
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('ListSlider', ['Hammer'], factory);
    } else {
        // Browser globals
        root.ListSlider = factory(root.Hammer);
    }
}(typeof self !== 'undefined' ? self : this, function (Hammer) {
        'use strict';

        function ListSlider(element, options) {
            this.container = element;
            this.strip = element.querySelector('ul');
            this.items = this.strip.children;
            this.hammer = (typeof (Hammer) !== 'undefined') ? new Hammer(element, { inputClass: Hammer.TouchMouseInput }) : null;

            this.next = this.next.bind(this);
            this.prev = this.prev.bind(this);
            this.goto = this.goto.bind(this);

            this.currentIndex = 0;

            this.goto(this.currentIndex);

            if (this.hammer) {
                this.hammer.get('swipe').set({ direction: Hammer.DIRECTION_HORIZONTAL });
                this.hammer.on('swipeleft', this.next);
                this.hammer.on('swiperight', this.prev);
            }
        }

        ListSlider.prototype = {
            goto: function (index) {
                index = Math.max(index, 0);
                index = Math.min(index, this.items.length - 1);
                this.currentIndex = index;
                var translate = this.items[0].clientWidth * this.currentIndex;
                this.strip.style.transform = 'translateX(-' + translate + 'px)';
            },
            next: function () {
                this.goto(this.currentIndex + 1);
            },
            prev: function () {
                this.goto(this.currentIndex - 1);
            }
        }

        return ListSlider;

}));